import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { redirectToPortal } from '../services/stripe';
import './BillingPage.css';

const BillingPage = () => {
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  // Placeholder data -- replace with real data from your backend/auth context
  const currentPlan = {
    name: 'Pro',
    status: 'Active',
    billingCycle: 'Monthly',
    nextBillingDate: 'May 4, 2026',
    price: '$10.00/mo',
  };

  const usage = {
    applicationsUsed: 47,
    applicationsLimit: 300,
    coldEmailsSent: 12,
    coldEmailsLimit: 600,
    coverLettersGenerated: 3,
    coverLettersLimit: 10,
  };

  const paymentHistory = [
    { date: 'Apr 4, 2026', description: 'Pro Plan -- Monthly', amount: '$10.00', status: 'Paid' },
    { date: 'Mar 4, 2026', description: 'Pro Plan -- Monthly', amount: '$10.00', status: 'Paid' },
    { date: 'Feb 4, 2026', description: 'Pro Plan -- Monthly', amount: '$10.00', status: 'Paid' },
    { date: 'Jan 4, 2026', description: 'Pro Plan -- Monthly', amount: '$10.00', status: 'Paid' },
  ];

  const usagePercent = (used, limit) => Math.min((used / limit) * 100, 100);

  const handleManageBilling = async () => {
    await redirectToPortal();
  };

  return (
    <div className="billing-page">
      <div className="billing-container">
        <h1 className="billing-title">Billing & Subscription</h1>
        <p className="billing-subtitle">Manage your plan, usage, and payment details.</p>

        {/* Current Plan Card */}
        <div className="billing-card">
          <div className="billing-card__header">
            <h2 className="billing-card__heading">Current Plan</h2>
            <span className="billing-status-pill">{currentPlan.status}</span>
          </div>
          <div className="billing-plan-details">
            <div className="billing-plan-info">
              <span className="billing-plan-name">{currentPlan.name}</span>
              <span className="billing-plan-price">{currentPlan.price}</span>
            </div>
            <div className="billing-plan-meta">
              <span>Billing cycle: {currentPlan.billingCycle}</span>
              <span>Next billing date: {currentPlan.nextBillingDate}</span>
            </div>
          </div>
          <div className="billing-card__actions">
            <Link to="/pricing" className="billing-btn billing-btn--primary">Change Plan</Link>
            <button onClick={handleManageBilling} className="billing-btn billing-btn--ghost">Manage Billing</button>
          </div>
        </div>

        {/* Usage Stats Card */}
        <div className="billing-card">
          <h2 className="billing-card__heading">Usage This Period</h2>
          <div className="billing-usage-grid">
            <div className="billing-usage-item">
              <div className="billing-usage-label">Applications</div>
              <div className="billing-usage-bar-wrapper">
                <div className="billing-usage-bar" style={{ width: `${usagePercent(usage.applicationsUsed, usage.applicationsLimit)}%` }} />
              </div>
              <div className="billing-usage-count">{usage.applicationsUsed} / {usage.applicationsLimit}</div>
            </div>
            <div className="billing-usage-item">
              <div className="billing-usage-label">Cold Emails Sent</div>
              <div className="billing-usage-bar-wrapper">
                <div className="billing-usage-bar" style={{ width: `${usagePercent(usage.coldEmailsSent, usage.coldEmailsLimit)}%` }} />
              </div>
              <div className="billing-usage-count">{usage.coldEmailsSent} / {usage.coldEmailsLimit}</div>
            </div>
            <div className="billing-usage-item">
              <div className="billing-usage-label">Cover Letters Generated</div>
              <div className="billing-usage-bar-wrapper">
                <div className="billing-usage-bar" style={{ width: `${usagePercent(usage.coverLettersGenerated, usage.coverLettersLimit)}%` }} />
              </div>
              <div className="billing-usage-count">{usage.coverLettersGenerated} / {usage.coverLettersLimit}</div>
            </div>
          </div>
        </div>

        {/* Payment History Card */}
        <div className="billing-card">
          <h2 className="billing-card__heading">Payment History</h2>
          <div className="billing-table-wrapper">
            <table className="billing-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory.map((row, i) => (
                  <tr key={i}>
                    <td>{row.date}</td>
                    <td>{row.description}</td>
                    <td>{row.amount}</td>
                    <td><span className="billing-paid-pill">{row.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Cancel Section */}
        <div className="billing-cancel-section">
          {!showCancelConfirm ? (
            <button
              className="billing-cancel-link"
              onClick={() => setShowCancelConfirm(true)}
            >
              Cancel Subscription
            </button>
          ) : (
            <div className="billing-cancel-confirm">
              <p className="billing-cancel-confirm__text">
                Are you sure? You will retain access until the end of your current billing period.
              </p>
              <div className="billing-cancel-confirm__actions">
                <button className="billing-btn billing-btn--danger">Confirm Cancellation</button>
                <button
                  className="billing-btn billing-btn--ghost"
                  onClick={() => setShowCancelConfirm(false)}
                >
                  Keep My Plan
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillingPage;
